import { render } from "./TopTemplate.vue?vue&type=template&id=6e0c2394"
import script from "./TopTemplate.vue?vue&type=script&lang=js"
export * from "./TopTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/toptemplate/TopTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e0c2394"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e0c2394', __exports__)) {
    console.log('reload')
    api.reload('6e0c2394', __exports__)
  }
  
  module.hot.accept("./TopTemplate.vue?vue&type=template&id=6e0c2394", () => {
    console.log('re-render')
    api.rerender('6e0c2394', render)
  })

}


export default __exports__